import { render, staticRenderFns } from "./dubletten-confirmation-table.vue?vue&type=template&id=32cac7d7&scoped=true"
import script from "./dubletten-confirmation-table.vue?vue&type=script&lang=js"
export * from "./dubletten-confirmation-table.vue?vue&type=script&lang=js"
import style0 from "./dubletten-confirmation-table.vue?vue&type=style&index=0&id=32cac7d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cac7d7",
  null
  
)

export default component.exports